import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { useState } from "react";

interface Props
{
    options: { [text: string]: () => void }
}

export default function EditCommentMenu({ options }: Props)
{
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () =>
    {
        setAnchorEl(null);
    };

    const doMenuAction = (action: () => void) =>
    {
        return () =>
        {
            action();
            handleClose();
        }
    }

    return (
        <Box>
            <Tooltip title="Settings">
                <IconButton
                    aria-haspopup="true"
                    id="comment-icon-button"
                    aria-controls="comment-menu"
                    aria-label="settings"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    size="large">
                    <MoreVert />
                </IconButton>
            </Tooltip>
            <Menu
                id="comment-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'settings',
                }}
            >
                {Object.entries(options).map(([text, action], index) =>
                {
                    return <MenuItem key={`Menu-${text}-${index}`} onClick={doMenuAction(action)}>{text}</MenuItem>
                })}
            </Menu>
        </Box>
    );
}